import { TFunction } from 'i18next';

export function translateError(t: TFunction, errorCodes: string[], i18nKey: string): string {
  return t([
    ...errorCodes.map((code): string => `${i18nKey}.${code}`),
    ...errorCodes.map((code): string => `errors.${code}`),
  ]);
}
